import { useState } from "react";
import Facebook from "../Assets/Images/ShareIcons/facebook.png";
import LinkedIn from "../Assets/Images/ShareIcons/linkedin.png";
import Email from "../Assets/Images/ShareIcons/message.png";
import X from "../Assets/Images/ShareIcons/twitter.png";
import Whatsapp from "../Assets/Images/ShareIcons/whatsapp.png";
import Share from "../Assets/Images/ShareIcons/share.png";
import "./ShareModal.css";
import { FaLink } from "react-icons/fa";

const ShareModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const pageUrl = encodeURIComponent(window.location.href);
  const message = encodeURIComponent("Check this out: ");

  // Social Media Share Links
  const shareLinks = {
    whatsapp: `https://wa.me/?text=${message}${pageUrl}`,
    twitter: `https://twitter.com/intent/tweet?text=${message}&url=${pageUrl}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`,
    email: `mailto:?subject=Check this out&body=${message}${pageUrl}`,
  };

  // Function to copy the link
  const copyToClipboard = () => {
    navigator.clipboard.writeText(window.location.href);
    alert("Link copied to clipboard!");
  };

  return (
    <div>
      {/* Share Button (Icon) */}
      <button onClick={() => setIsOpen(true)} className="shareBtn">
        <img src={Share} className="shareModalIcon flaticons" alt="Share"/>
      </button>

      {/* Modal */}
      {isOpen && (
        <div className="modalOverlay" onClick={() => setIsOpen(false)}>
          <div className="modalContent" onClick={(e) => e.stopPropagation()}>
            <span className="closeBtn" onClick={() => setIsOpen(false)}>
              &times;
            </span>
            <h2 className="shareHeading">Share this page</h2>
            <div className="shareIcons">
  <a href={shareLinks.whatsapp} target="_blank" rel="noopener noreferrer" className="share whatsapp">
    <img src={Whatsapp} alt="WhatsApp" />
  </a>

  <a href={shareLinks.twitter} target="_blank" rel="noopener noreferrer" className="share twitter">
    <img src={X} alt="Twitter/X" />
  </a>

  <a href={shareLinks.facebook} target="_blank" rel="noopener noreferrer" className="share facebook">
    <img src={Facebook} alt="Facebook" />
  </a>

  <a href={shareLinks.linkedin} target="_blank" rel="noopener noreferrer" className="share linkedin">
    <img src={LinkedIn} alt="LinkedIn" />
  </a>

  <a href={shareLinks.email} className="share email">
    <img src={Email} alt="Email" />
  </a>

  <button onClick={copyToClipboard} className="share copy">
    <FaLink size={24} />
  </button>
</div>

          </div>
        </div>
      )}
    </div>
  );
};

export default ShareModal;
